import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Card as CardMaterial,
  Typography,
  Collapse,
} from '@material-ui/core'
import { ToggleButton } from 'components'

import useStyles from './styles'
import theme from 'theme'

const Card = ({
  id,
  title,
  dropdown = false,
  children,
  actionButton = null,
  expandedOption = false,
  paddingBottom = 2,
  childrenStyle = null,
  actionButtonEnd = false,
  headerContainerProps = {},
  footerContainerProps = {},
}) => {
  const classes = useStyles()
  const [expanded, setExpanded] = useState(expandedOption)

  useEffect(() => {
    setExpanded(expandedOption)
  }, [expandedOption])

  return (
    <Box pb={paddingBottom} id={id}>
      <CardMaterial>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          className={classes.borderBottom}
          pl={2}
          py={2}
          {...headerContainerProps}
          gridGap={theme.spacing(1)}
        >
          {React.isValidElement(title) ? (
            title
          ) : (
            <Typography variant="h5">{title}</Typography>
          )}
          <Box display="flex" justifyContent="center" alignItems="center">
            {actionButton && !actionButtonEnd && (
              <Box pr={1}>{actionButton}</Box>
            )}
            {dropdown && (
              <Box pr={1}>
                <ToggleButton
                  size={18}
                  expanded={expanded}
                  onClick={() => setExpanded(!expanded)}
                />
              </Box>
            )}
          </Box>
        </Box>
        {children && !dropdown ? (
          <Box style={childrenStyle || { padding: 16 }}>{children}</Box>
        ) : (
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            {children}
          </Collapse>
        )}
        {actionButton && actionButtonEnd && (
          <Box p={2} className={classes.buttonEnd} {...footerContainerProps}>
            {actionButton}
          </Box>
        )}
      </CardMaterial>
    </Box>
  )
}

Card.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  dropdown: PropTypes.bool,
  children: PropTypes.node,
  actionButton: PropTypes.node,
  expandedOption: PropTypes.bool,
  paddingBottom: PropTypes.number,
  childrenStyle: PropTypes.object,
  headerContainerProps: PropTypes.object,
  footerContainerProps: PropTypes.object,
}

export default Card
